"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { billingOverviewQueryPrefix } from "@/hooks/queries/billing-overview"
import { useTranslatedQueryHandling } from "@/hooks/use-translated-query-handling"
import { prepareAgentCreationAction, personalizeAgentCreationAction, regenerateAgentCreationAction, createWizardAgentAction, prepareWizardVoiceOpeningAction } from "@/server-actions/agent-creation"

export function usePrepareAgentCreationMutation() {
  const handle = useTranslatedQueryHandling()
  const client = useQueryClient()
  return useMutation({
    mutationFn: async (input: Parameters<typeof prepareAgentCreationAction>[0]) => {
      const result = await handle(prepareAgentCreationAction(input))
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    }, onSettled: () => { void client.invalidateQueries({ queryKey: billingOverviewQueryPrefix }) }
  })
}
export function usePersonalizeAgentCreationMutation() {
  const handle = useTranslatedQueryHandling()
  const client = useQueryClient()
  return useMutation({
    mutationFn: async (input: Parameters<typeof personalizeAgentCreationAction>[0]) => {
      const result = await handle(personalizeAgentCreationAction(input))
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    }, onSettled: () => { void client.invalidateQueries({ queryKey: billingOverviewQueryPrefix }) }
  })
}
export function useRegenerateAgentCreationMutation() {
  const handle = useTranslatedQueryHandling()
  const client = useQueryClient()
  return useMutation({
    mutationFn: async (input: Parameters<typeof regenerateAgentCreationAction>[0]) => {
      const result = await handle(regenerateAgentCreationAction(input))
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    }, onSettled: () => { void client.invalidateQueries({ queryKey: billingOverviewQueryPrefix }) }
  })
}
export function useCreateWizardAgentMutation() {
  const handle = useTranslatedQueryHandling()
  return useMutation({
    mutationFn: async (input: Parameters<typeof createWizardAgentAction>[0]) => {
      const result = await handle(createWizardAgentAction(input))
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    }
  })
}
export function useWizardVoiceOpeningMutation() {
  const handle = useTranslatedQueryHandling()
  return useMutation({
    mutationFn: async (input: Parameters<typeof prepareWizardVoiceOpeningAction>[0]) => {
      const result = await handle(prepareWizardVoiceOpeningAction(input))
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    }
  })
}
